import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file-share-save",
  "use": "icon-file-share-save-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-file-share-save\"><defs><style type=\"text/css\"></style></defs><path d=\"M547.4 65.9h124.4v203.7H547.4z\" p-id=\"5659\" /><path d=\"M218.7 589.9h597v29.5h-597zM218.7 728h597v29.5h-597zM218.7 870.3h597v29.5h-597z\" p-id=\"5660\" /><path d=\"M999.3 210.6L816.9 23.9c-8.5-8.7-18.9-15.4-30.3-19.5C770-1.6 752.4 0.3 735.2 0.3h-661c-39.6 0-72 32.4-72 72v878.5c0 39.6 32.4 72 72 72h876c39.6 0 72-32.4 72-72V277.1c0-12.6 0.2-24-3.9-36.1-4.1-11.4-10.5-21.8-19-30.4z m-682-183H729.7V325H317.3V27.6z m580.4 964H132.4V504.7H897.7v486.9z m93-114.2h-59.6v-50.8h59.6v50.8z\" p-id=\"5661\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file-share-save.svg
// module id = BEyy
// module chunks = 22